import { ErrorHandler, ErrorResponse } from '@apollo/link-error'

const errorLogger: ErrorHandler = ({
  graphQLErrors,
  networkError,
  operation,
}: ErrorResponse) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      // eslint-disable-next-line no-console
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    )
  }

  if (networkError) {
    const errorDetails = {
      name: networkError.name,
      message: networkError.message,
      operation: operation.operationName,
      variables: operation.variables,
    }

    // eslint-disable-next-line no-console
    console.error(
      `[Network error]: ${networkError.name}: ${networkError.message}`,
      errorDetails
    )

    // Specific handling for ServerParseError
    if (networkError.name === 'ServerParseError') {
      // eslint-disable-next-line no-console
      console.error(
        '[ServerParseError]: Server sent malformed JSON. Check server logs for further info.'
      )
    }
  }
}

export { errorLogger }
